import { alpha, PaletteOptions } from '@mui/material'
import { colors } from './constants'

const palette: PaletteOptions = {
  action: {
    active: colors.grey[900],
    hover: alpha(colors.grey[900], 0.06),
    hoverOpacity: 0.06,
    selected: alpha(colors.grey[900], 0.1),
    disabled: colors.grey[900],
    disabledBackground: alpha(colors.grey[900], 0.38),
  },
  background: {
    paper: colors.white,
    default: colors.background,
  },
  primary: {
    light: colors.teal[200],
    main: colors.teal[300],
    dark: colors.teal[500],
  },
  secondary: {
    light: colors.black,
    main: colors.black,
    dark: colors.teal[500],
  },
  success: {
    main: colors.successGreen,
  },
  error: {
    light: colors.red[400],
    main: colors.red[700],
    dark: colors.red[900],
  },
  text: {
    primary: alpha(colors.grey[900], 1),
    secondary: alpha(colors.grey[900], 0.8),
    disabled: alpha(colors.grey[900], 0.38),
  },
  divider: colors.grey[300],
}

export { palette }
